'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _require = require('@ali/intl-universal'),
    provideIntl = _require.provideIntl,
    destroyIntl = _require.destroyIntl;

var strings = require('./strings');

var intl = void 0;
var MEDUSA_APP_NAME = 'legao-designer';
var PSEUDO_LANGUAGE_TAG = 'pd-KV';
var CURRENT_LANGUAGE = (window.locale || window.localStorage.getItem('vdev-locale') || '').replace(/_/, '-') || 'zh-CN';

function update(language) {
  destroyIntl();
  intl = provideIntl({
    locale: language,
    messagesAIO: strings
  });
}

function get(id, variable) {
  if (!intl) update();
  var string = '';
  var key = '';
  if (typeof id === 'string') {
    key = id;
    string = intl.formatMessage({ id: id }, variable);
  }
  if ((typeof id === 'undefined' ? 'undefined' : _typeof(id)) === 'object' && id.dm) {
    id.defaultMessage = id.dm;
  }
  key = id.id;
  string = intl.formatMessage(id, variable);
  if (CURRENT_LANGUAGE === PSEUDO_LANGUAGE_TAG) {
    return '##@@@' + key + '##' + MEDUSA_APP_NAME + '@@@##' + string;
  }
  return string;
}

if (PSEUDO_LANGUAGE_TAG === CURRENT_LANGUAGE) {
  update('en-US');
} else {
  update(CURRENT_LANGUAGE);
}

module.exports = {
  get: get,
  update: update
};